const sfxLocale = {
  en: {
    password: {
      blank: 'Password can\'t be blank.',
      invalid: 'Passwords should be at least 8 characters long and include at least 1 number and 1 letter.'
    },
    email: {
      blank: 'Email can\'t be blank.',
      invalid: 'Email is invalid.'
    },
    type: {
      unselected: 'Please select customer type'
    }
  },
  es: {
    password: {
      blank: 'Contraseña no puede estar en blanco.',
      invalid: 'Las contraseñas deben tener al menos 8 caracteres, incluido 1 número y 1 carácter alfanumérico.'
    },
    email: {
      blank: 'Correo electrónico no puede estar en blanco.',
      invalid: 'Correo electrónico no válido.'
    },
    type: {
      unselected: 'Por favor seleccione tipo de cliente'
    }
  },
  fr: {
    password: {
      blank: 'Mot de passe ne peut pas rester vide.',
      invalid: 'Les mots de passe doivent comporter au moins 8 caractères dont 1 chiffre et 1 caractère alphanumérique.'
    },
    email: {
      blank: 'E-mail ne peut pas rester vide.',
      invalid: 'E-mail est invalide.'
    },
    type: {
      unselected: 'Veuillez sélectionner le type de client'
    }
  },
  pl: {
    password: {
      blank: 'Hasło nie może być pusty.',
      invalid: 'Hasła powinny składać się z co najmniej 8 znaków, w tym 1 cyfry i 1 znaku alfanumerycznego.'
    },
    email: {
      blank: 'E-mail nie może być pusty.',
      invalid: 'E-mail jest nieważny.'
    },
    type: {
      unselected: 'Proszę wybrać typ klienta'
    }
  }
}
  
function initPasswordReset(form) {
  const submitBtn = form.querySelector('button')
  submitBtn.addEventListener('click', function (event) {
    event.preventDefault()
    validatePasswordReset(form)
  })
}
  
function validatePasswordReset(form) {
  const passwordInput = form.querySelector('#password')

  hideErrors(form)

  const errorMsgs = []
  const passwordVal = passwordInput.value

  const passwordValidity = passwordValidation(passwordVal)

  if (!passwordValidity.isValid) {
    passwordInput.classList.add('form-field-error')
    errorMsgs.push(passwordValidity.msg)
  }

  if (errorMsgs.length) {
    showErrors(form, errorMsgs)
  } else {
    form.submit()
  }
}
  
function initCustomerRegistration(createCustomerForm) {
  const regButton = createCustomerForm.querySelector('#create_customer_button')
  regButton.addEventListener('click', function (event) {
    event.preventDefault()
    validateSubmission(createCustomerForm)
  })
}
  
function validateSubmission(form) {
  const regType = form.querySelector('#register_type')
  const regEmail = form.querySelector('#register_email')
  const regPassword = form.querySelector('#register_password')
  
  hideErrors(form)

  const errorMsgs = []
  const typeVal = regType.value
  const emailVal = regEmail.value
  const passwordVal = regPassword.value

  const typeValidity = custTypeValidation(typeVal)
  const emailValidity = emailValidation(emailVal)
  const passwordValidity = passwordValidation(passwordVal)

  if (!typeValidity.isValid) {
    regType.classList.add('form-field-error')
    errorMsgs.push(typeValidity.msg)
  }

  if (!emailValidity.isValid) {
    regEmail.classList.add('form-field-error')
    errorMsgs.push(emailValidity.msg)
  }

  if (!passwordValidity.isValid) {
    regPassword.classList.add('form-field-error')
    errorMsgs.push(passwordValidity.msg)
  }

  if (errorMsgs.length) {
    showErrors(form, errorMsgs)
  } else {
    form.submit()
  }
}

function custTypeValidation(value) {
  if (!value.length) {
    return {
      isValid: false,
      msg: sfxLocale[window.Shopify.locale].type.unselected
    }
  }

  return {
    isValid: true
  }
}
  
function emailValidation(value) {
  const emailRegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

  if (value.length == 0) {
    return {
      isValid: false,
      msg: sfxLocale[window.Shopify.locale].email.blank
    }
  }

  if (!emailRegExp.test(value)) {
    return {
      isValid: false,
      msg: sfxLocale[window.Shopify.locale].email.invalid
    }
  }

  return {
    isValid: true
  }
}
  
function passwordValidation(value) {
  const passwordRegEx = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$/

  if (value.length == 0) {
    return {
      isValid: false,
      msg: sfxLocale[window.Shopify.locale].password.blank
    }
  }
  
  if (!passwordRegEx.test(value)) {
    return {
      isValid: false,
      msg: sfxLocale[window.Shopify.locale].password.invalid
    }
  }

  return {
    isValid: true
  }
}
  
function hideErrors(form) {
  const messageDiv = form.querySelector('.account-message.form-message.message--error')
  if (messageDiv) messageDiv.remove()
}
  
function showErrors(form, errorMsgs) {
  const messageDiv = document.createElement('div')
  messageDiv.classList.add('account-message', 'form-message', 'message--error')

  const errorsDiv = document.createElement('div')
  errorsDiv.classList.add('errors')

  const errorsList = document.createElement('ul')

  errorsDiv.append(errorsList)
  messageDiv.append(errorsDiv)
  form.prepend(messageDiv)

  let errorItem

  errorMsgs.forEach(function (msg) {
    errorItem = document.createElement('li')
    errorItem.innerHTML = msg
    errorsList.append(errorItem)
  })
}

const elements = document.getElementsByClassName('product-vendor-logo')

for (const el of elements) {
  const vendorName = el.dataset.vendorName

  const vandorHandle = vendorName.replace(' ', '_')

  const imgSrc = `https://media.screwfix.eu/is/image/ae235/?src=ae235/${vandorHandle}&wid=150`

  const img = new Image()
  img.src = imgSrc
  img.setAttribute('alt', `${vendorName} Logo`);

  img.onload = function() {
    el.appendChild(img)
  }
}
  
window.addEventListener("DOMContentLoaded", () => {

  // Mega menu
  const navLevel2Links = document.querySelectorAll('.navmenu-depth-2 > li > a')

  navLevel2Links.forEach(element => {
    // console.log(element)
  })

  // Cookie Preferences Popup Trigger
  const cookiePrefsLinks = document.querySelectorAll("a[href$='/#cookie-preferences']");
  cookiePrefsLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
      truste.eu.clickListener(1)
    })
  })

  /*
  Customer Registration Form
  */
  const createCustomerForm = document.getElementById('create_customer')
  if (createCustomerForm) {
    initCustomerRegistration(createCustomerForm)
  }

  /*
  Customer Password Reset Form
  */
  const passwordResetForm = document.querySelector('.account-page-reset-password form')
  if (passwordResetForm) {
    initPasswordReset(passwordResetForm)
  }


  const items = document.querySelectorAll(".fud-item");
  let currentIndex = 0;

  function showNextMessage() {
      items.forEach((item, index) => {
          item.classList.remove("active");
          if (index === currentIndex) {
              item.classList.add("active");
          }
      });

      currentIndex = (currentIndex + 1) % items.length; // Loop back to the first message
  }

  showNextMessage();

  setInterval(showNextMessage, 3000);
})

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

document.addEventListener("DOMContentLoaded", function() {
  // Function to check if the element is in the viewport
  function isElementInViewport(el) {
      var rect = el.getBoundingClientRect();
      return (
          rect.top >= -140 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
  }

  // Function to add or remove class based on element visibility
  function toggleClassBasedOnVisibility() {
      var formArea = document.querySelector('[data-product-form-area]');
      var stickyCartWrapper = document.querySelector('.sticky-cart-wrapper');

      if (!formArea || !stickyCartWrapper) {
          // If either the form area or the sticky cart wrapper is not found, exit
          return;
      }

      if (!isElementInViewport(formArea)) {
          // If the form area is not visible, add the class to the sticky cart wrapper
          stickyCartWrapper.classList.add('atc-not-visible');
      } else {
          // If the form area is visible, remove the class from the sticky cart wrapper
          stickyCartWrapper.classList.remove('atc-not-visible');
      }
  }

  // Initial check on document ready
  toggleClassBasedOnVisibility();

  // Check visibility on scroll
  window.addEventListener('scroll', function() {
      toggleClassBasedOnVisibility();
  });
});
document.addEventListener("DOMContentLoaded", function() {
  const readMoreBtns = document.querySelectorAll('.read-more-btn');

  readMoreBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
          const description = this.closest('.read-more-description');
          const p = description.querySelector('p');
          description.classList.toggle('show-more');
      });
  });

  let lastScrollY = window.scrollY;
  let isScrollBound = false;

  function isMobile() {
    return window.innerWidth <= 767;
  }

  function handleScroll() {
    const header = document.querySelector('.site-header-sticky .site-header');
    const collection = document.querySelector('.template-collection.site-header-sticky');
    if (!header) return;

    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY) {
      header.classList.add('hide-on-scroll');
      if(collection){
        collection.classList.add('collection-hide-on-scroll');
      }
    } else {
      header.classList.remove('hide-on-scroll');
      if(collection){
        collection.classList.remove('collection-hide-on-scroll');
      }
    }

    lastScrollY = currentScrollY;
  }

  function updateScrollBinding() {
    const header = document.querySelector('.site-header-sticky .site-header');

    if (isMobile() && header && !isScrollBound) {
      window.addEventListener('scroll', handleScroll);
      isScrollBound = true;
    } else if (!isMobile() && isScrollBound) {
      window.removeEventListener('scroll', handleScroll);
      isScrollBound = false;

      // Reset header state
      if (header) {
        header.classList.remove('hide-on-scroll');
      }
    }
  }

  updateScrollBinding();
  window.addEventListener('resize', updateScrollBinding);
});

(function () {
  const flickityInstances = [];

  function initMobileSliders() {
    const isMobile = window.innerWidth < 768;
    const carousels = document.querySelectorAll('.promo-carousel');

    if (!carousels.length) return; // ✅ Exit early if no carousels

    carousels.forEach((carousel, index) => {
      const isInitialized = carousel.classList.contains('flickity-enabled');

      // 🔄 Destroy if not mobile and already initialized
      if (!isMobile && isInitialized && flickityInstances[index]) {
        flickityInstances[index].destroy();
        flickityInstances[index] = null;
        return;
      }

      // 🚀 Initialize if mobile and not yet initialized
      if (isMobile && !isInitialized) {
        const flkty = new Flickity(carousel, {
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          wrapAround: true,
          groupCells: 1,
          prevNextButtons: true
        });
        flickityInstances[index] = flkty;
      }
    });
  }

  window.addEventListener('load', initMobileSliders);
  window.addEventListener('resize', initMobileSliders);
})();
